import { NgClass } from '@angular/common';
import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { Checkbox } from 'primeng/checkbox';
import { InputMask } from 'primeng/inputmask';
import { InputText } from 'primeng/inputtext';
import { Select } from 'primeng/select';
import { CustomerGroup } from '../../../../content/enums/organisation/customer-group';
import { CustomerType } from '../../../../content/enums/organisation/customer-type';
import { OrganisationData } from '../../../../content/interfaces/organisation/organisation-data';
import { OrganisationDataInvalidFlags } from '../../../../content/interfaces/organisation/organisation-data-invalid-flags';
import { SettingsProviderService } from '../../../../content/services/settings-provider.service';
import { HelperService } from '../../../../core/services/helper.service';
import { I18nService } from '../../../../core/services/i18n.service';

@Component({
  selector: 'customer-data-edit-dialog',
  imports: [
    InputText,
    Select,
    FormsModule,
    NgClass,
    InputMask,
    Checkbox
  ],
  templateUrl: './customer-data-edit-dialog.component.html',
})
export class CustomerDataEditDialogComponent implements OnInit {

  public i18n = inject(I18nService);
  public settingsProvider = inject(SettingsProviderService);
  private helperService = inject(HelperService);

  dataValid: boolean = false;
  protected showInvalidCreditorId: boolean;
  protected showInvalidVatId: boolean;
  protected readonly CustomerType = CustomerType;

  @Input() organisationData: OrganisationData;
  @Input() referralPartnerList: SelectItem[] = [];
  @Input() organisationBankList: SelectItem[] = [];
  @Input() organisationRzList: SelectItem[] = [];
  @Input() organisationDataInvalidFlags: OrganisationDataInvalidFlags;
  @Output() dataValidated = new EventEmitter();


  ngOnInit() {
    /**
     * Initialize undefined data if necessary
     */
    if (this.organisationData?.sapCustomerNumber === undefined) {
      this.organisationData.sapCustomerNumber = null;
    }
    if (!this.organisationData?.customerGroup) {
      this.organisationData.customerGroup = CustomerGroup.DIRECT;
    }
    if (!this.organisationData?.url || this.organisationData?.url.trim().length === 0) {
      this.organisationData.url = 'https://';
    }
  }

  /**
   * validate Organisation-Data
   */
  validateData() {
    this.dataValid = true;
    if (!this.organisationData?.customerType) {
      this.dataValid = false;
    }
    if (!this.organisationData?.organisationType) {
      this.dataValid = false;
    }
    if (!this.organisationData?.customerType) {
      this.dataValid = false;
    }
    if (!this.organisationData?.streetNr || this.organisationData?.streetNr.trim().length === 0) {
      this.dataValid = false;
    }
    if (!this.organisationData?.postalCode || this.organisationData?.postalCode.trim().length < 5) {
      this.dataValid = false;
    }
    if (!this.organisationData?.city || this.organisationData?.city.trim().length === 0) {
      this.dataValid = false;
    }
    if (!this.organisationData?.url || !this.helperService.isValidHttpsUrl(this.organisationData?.url)) {
      this.dataValid = false;
    }
    /* Kein Pflichtfeld mehr, Anforderung vom 21.20.2026
    if (!this.organisationData?.email || !this.helperService.isValidEmail(this.organisationData?.email)) {
      this.dataValid = false;
    }
     */
    if (!this.organisationData?.vatId) {
      this.checkVatId();
    }
    if (!this.organisationData?.creditorId) {
      this.checkCreditorId();
    }
    if (!this.organisationData?.paymentMethod) {
      this.dataValid = false;
    }
    if (this.organisationData?.paymentMethod && this.organisationData?.paymentMethod === 'CUSTOMERPAYMENTDIRECTDEBIT') {
      if (!this.organisationData?.mandateReference || this.organisationData?.mandateReference.trim().length === 0) {
        this.dataValid = false;
      }
      if (this.organisationData.mandateReference) {
        this.organisationData.mandateReference = this.organisationData?.mandateReference.toUpperCase();
      }
    }
    this.dataValidated.emit(this.dataValid);
  }

  /**
   * check organisation type for visible referral-flag
   * @protected
   */
  protected checkCustomerType() {
    if (this.organisationData.customerType === CustomerType.KOMMUNE) {
      this.organisationData.isReferralPartner = false;
    }
    this.validateData();
  }

  /**
   * TODO check for valid vat id - if needed
   * @protected
   */
  protected checkVatId() {

  }

  /**
   * TODO check for valid creditor id - if needed
   * @protected
   */
  protected checkCreditorId() {

  }

}
